import React from 'react';
import ReactDOM from 'react-dom/client';
import { RehubSupabaseTracking } from '@rehub/tracking/react';
import App from './App';
import { supabase } from './services/supabase';

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error, info: React.ErrorInfo) { console.error('App error:', error, info); }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, color: '#f0f0f5', fontFamily: 'system-ui', backgroundColor: '#111118', minHeight: '100vh' }}>
          <h1>Something went wrong</h1>
          <pre style={{ color: '#ff6b6b', overflow: 'auto' }}>{this.state.error.message}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
      <RehubSupabaseTracking app="floorplan" mode="events-only" supabase={supabase} />
    </ErrorBoundary>
  </React.StrictMode>
);
